import client from '../../base-api';

const serviceURL = '/unemployed/private-learning-coaching';

const unemployedPrivateLearningCoachingService = {
    getPrivateLearningCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getPrivateLearningCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postPrivateLearningCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putPrivateLearningCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    deletePrivateLearningCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
}

export default unemployedPrivateLearningCoachingService;